import ReactDOM from "react-dom/client";
import "./styles/bootstrap/bootstrap.scss";
import "./styles/bootstrap/overrides.css";
import AppRoutes from "./routes";
import "components/i18n/init";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<AppRoutes />);
